
import { createRouter, createWebHistory } from 'vue-router';

import TileView from '../views/TileView.vue';
import MonitorView from '../views/MonitorView.vue';
import CSVDownloadView from '../views/CSVDownloadView.vue';
import RemoteControlView from '../views/RemoteControlView.vue';
import ActionLogView from '../views/ActionLogView.vue';
import MonitorEditView from '../views/MonitorEditView.vue';
import ModuleSettingsView from '../views/ModuleSettingsView.vue';
import AnnounceView from '../views/AnnounceView.vue';

const routes = [
  {
    path: '/',
    redirect: '/tile'
  },
  {
    path: '/tile',
    name: 'tile',
    component: TileView
  },
  {
    path: '/monitor',
    name: 'monitor',
    component: MonitorView
  },
  {
    path: '/csv-download',
    name: 'csv-download',
    component: CSVDownloadView
  },
  {
    path: '/remote-control',
    name: 'remote-control',
    component: RemoteControlView
  },
  {
    path: '/action-log',
    name: 'action-log',
    component: ActionLogView
  },
  {
    path: '/monitor-edit',
    name: 'monitor-edit',
    component: MonitorEditView
  },
  {
    path: '/module-settings',
    name: 'module-settings',
    component: ModuleSettingsView
  },
  {
    path: '/announce',
    name: 'announce',
    component: AnnounceView
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router
